type Glob = "textures";

//
// Create an object mapping from basename => url for an asset glob path. Note that `glob` is a
// lookup, because import.meta.glob requires static strings. This technique from:
//
// https://github.com/vitejs/vite/issues/5478
//

export function globber<T extends string>(glob: Glob): Record<T, string> {
  let raw: Record<string, { default: string }>;
  switch (glob) {
    case "textures":
      raw = import.meta.glob("@/assets/textures/*.png", { eager: true, query: "?url" });
      break;
  }

  const globber = {} as Record<T, string>;
  for (const [path, module] of Object.entries(raw)) {
    const key = path.match(/(\w+)\.\w+$/)?.[1];
    const url = module.default;
    globber[key as T] = url;
  }
  return globber;
}
